export default class MxConstants {
  //Actuator Models
  static F43002 = 'F430/2';
  static F43004 = 'F430/4';
  static F430R8 = 'F430R8';
  static F430R3V10 = 'F430R3V10';
  static F430V10 = 'F430V10';
  static F401 = 'F401'; //LR used for Preset
  static K8002S = 'K8002S'; //LR used for Preset
  static H4661M2 = 'H4661M2'; //LR used for Preset
  static K4672M2S = 'K4672M2S'; //LR used for Preset, also model used with commands

  //Command Models
  static K4652M2 = 'K4652M2'; //LR used for Preset
  static K4652M3 = 'K4652M3'; //LR used for Preset
  static F428 = 'F428';
  static H4652_3 = 'H4652/3';

  //Thermostat Models
  static ModelBT3454 = 'BT-3454';
  static ModelKG4691 = 'KG4691';
  static ModelKW4691 = 'KW4691';
  static ModelLN4691 = 'LN4691';
  static Model067459 = '067459';
  static Model64170 = '64170';
}
